import { useState } from "react";
import { Link, useNavigate } from "@tanstack/react-router";
import { api } from "../api";
import { hasPendingClaim } from "../claim";
import { AuthError, AuthField, AuthShell } from "../components/AuthShell";

export default function Login() {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await api.login(u, p);
      if (hasPendingClaim()) {
        nav({ to: "/settings", search: { section: "connectors" } });
      } else {
        nav({ to: "/" });
      }
    } catch (e) {
      setErr(
        e instanceof Error && /429|too many/i.test(e.message)
          ? "Too many attempts. Wait a minute and try again."
          : "Invalid credentials",
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthShell
      title="Sign in"
      subtitle="Enter your credentials to continue."
      footer={
        <>
          <p>
            Have a new IntraScene box?{" "}
            <Link to="/box" className="font-medium text-brand-fuchsia hover:underline">
              I have a box
            </Link>
          </p>
          <p className="text-xs text-bf-muted/70">Secure access to your surveillance intelligence</p>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <AuthField
          label="Username or email"
          autoFocus
          value={u}
          onChange={(e) => setU(e.target.value)}
          autoComplete="username"
          required
        />
        <AuthField
          label="Password"
          type="password"
          value={p}
          onChange={(e) => setP(e.target.value)}
          autoComplete="current-password"
          required
        />
        <AuthError message={err} />
        <button className="bf-button w-full py-2.5" disabled={loading} type="submit">
          {loading ? "Signing in..." : "Sign in"}
        </button>
        <div className="text-right">
          <Link to="/reset" className="text-xs text-bf-muted hover:text-bf-text">
            Forgot your password?
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}
